"use client";

import { createContext, use, useCallback, useMemo, useState } from "react";

type FreshnessContextValue = {
  latestDate?: string | null;
  lastUpdatedAt?: string | null;
  /** Set when the page shows a past chart: the header then names this day and never says Live. */
  pastDay?: string | null;
  setLatestDate: (d?: string | null) => void;
  setLastUpdatedAt: (d?: string | null) => void;
  setPastDay: (d: string | null) => void;
};

const FreshnessContext = createContext<FreshnessContextValue | undefined>(undefined);

export function DataFreshnessProvider({ children }: { children: React.ReactNode }) {
  const [latestDate, setLatestDateState] = useState<string | null | undefined>(undefined);
  const [lastUpdatedAt, setLastUpdatedAtState] = useState<string | null | undefined>(undefined);
  const [pastDay, setPastDay] = useState<string | null>(null);
  const setLatestDate = useCallback((d?: string | null) => {
    setLatestDateState(d ?? null);
  }, []);
  const setLastUpdatedAt = useCallback((d?: string | null) => {
    setLastUpdatedAtState(d ?? null);
  }, []);
  const value = useMemo(() => ({ latestDate, lastUpdatedAt, pastDay, setLatestDate, setLastUpdatedAt, setPastDay }), [latestDate, lastUpdatedAt, pastDay, setLatestDate, setLastUpdatedAt]);
  return <FreshnessContext.Provider value={value}>{children}</FreshnessContext.Provider>;
}

export function useDataFreshness() {
  const ctx = use(FreshnessContext);
  if (!ctx) throw new Error("useDataFreshness must be used within DataFreshnessProvider");
  return ctx;
}


